import { Spinner } from '@/components/ui/spinner';
import { useSnapshotDeviceQuery } from '@/hooks/connectNewDevice';
import { AssetVideoConfigDto, AssetVideoProcessorDto } from '@/types/datalayer-asset';
import { AspectRatio } from '@radix-ui/react-aspect-ratio';
import { useState } from 'react';

function SnapshotCard({
  id,
  setSnapshotReady,
}: {
  id: string;
  setSnapshotReady: (ready: boolean) => void;
}) {
  const [invalid, setInvalid] = useState(false);

  const { data, isLoading, isError } = useSnapshotDeviceQuery({ id: id, enabled: true });
  return (
    <>
      {data && !invalid && (
        <div className="h-full flex-grow basis-16">
          <img
            className="h-full object-cover"
            src={`data:image/png;base64, ${data}`}
            onLoad={() => {
              setSnapshotReady(true);
            }}
            onError={() => {
              setInvalid(true);
            }}
            alt="Camera Snapshot"
          />
        </div>
      )}
    </>
  );
}

export interface CamSneakPreviewProps {
  VPCs: (string | undefined)[];
}

export default function CamSneakPreview({ VPCs }: CamSneakPreviewProps) {
  const [snapshotReady, setSnapshotReady] = useState(false);

  return (
    <div className="absolute bottom-0 left-0 right-0 top-0 -z-0">
      <AspectRatio ratio={16 / 9}>
        <div className="flex h-full flex-row flex-wrap content-start overflow-hidden opacity-40">
          {VPCs.filter((x) => x)
            .slice(0, 4)
            .map((VPC, index) => (
              <SnapshotCard key={index} id={VPC ?? ''} setSnapshotReady={setSnapshotReady} />
            ))}
          {!snapshotReady && (
            <div className="flex h-full flex-grow items-center justify-center">
              <Spinner size={'large'} className="text-white" />
            </div>
          )}
        </div>
      </AspectRatio>
    </div>
  );
}
